export default __webpack_public_path__ + "static/media/Perfect_Record_Bulk_Upload_Template.28e7b791.xlsx";